// extracted by mini-css-extract-plugin
export default {"hero":"PageHero_hero__iJFSU","background-image":"PageHero_background-image__F3-ui","mobile-background-image":"PageHero_mobile-background-image__MGVpq"};